module.exports = __webpack_public_path__ + "static/media/lmc.35aec4aa.png";